<template>
	<div>
		
		<!-- confirmation dialog box -->
		<v-dialog v-model="dialog.flag" width="400" >
			<v-card class="elevation-0">
				<div  class="px-8 pt-2" v-if="dialog.order">
					<p class="page-title mb-5 mt-2">{{$lang.APPROVE_SUBSCRIPTION.toUpperCase()}}</p>
					<!-- {{dialog.order}} -->
					<!-- <div  v-if="payment_method=='IMPS/NEFT'" class="custome-form step-div" > -->
						<div v-if="dialog.order.payment_mode==$keys.OPTION_NEFT">
							<div class="custom-form pt-5">
								<label>{{$lang.NEFT_TRANSACTION_ID}}</label>
								<v-text-field
								:placeholder="$lang.NEFT_TRANSACTION_ID"
								v-model="dialog.neft_ref_no"
								single-line
								outlined
								dense
								:maxlength="25"
								></v-text-field>
							</div>
						</div>
						<div v-if="dialog.order.payment_mode==$keys.OPTION_CHEQUE">
							<div class="custom-form pt-5">
								<label>{{$lang.CHEQUE_NUMBER}}</label>
								<v-text-field
								:placeholder="$lang.CHEQUE_NUMBER"
								v-model="dialog.cheque_number"
								single-line
								outlined
								dense
								:maxlength="25"
								></v-text-field>
							</div>
						</div>
					</div>				
					<v-card-actions class="text-center pb-5">
						<v-spacer></v-spacer>
						<v-btn color="primary" :loading="btn_loading"  :disabled="!(dialog.cheque_number||dialog.neft_ref_no)?true:false" @click="continueHandler"> <b>{{$lang.CONTINUE}} </b></v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</template>
	<script>
	export default{
		props:['dialog','confirmSubsription'],
		data(){
			return{
				btn_loading:false,
				form:{
					cheque_number:"",
					transaction_date:"",
					neft_ref_no:"",
				}
			}
		},
		methods:{
			continueHandler(){
				this.$emit("approved",this.form)
			}
		}
	}

	</script>